import React from 'react';
import { loadFromLocalStorage } from '../../Common/Validation/LocalStorage';
import DataGrid from '../../Component/DataGrid/DataGrid';
import './TransactionLogs.css';
import { TableColumn } from 'react-data-table-component';
import TransactionService from '../../Services/TransactionService';
import { amountFormat } from '../../Component/helper';
import moment from 'moment';
import { ITransactionLogs, TransactionLogsProps, TransactionLogsState } from './Interface';
import TransactionDetails from './TransactionDetails/TransactionDetails';
import CustomMaterialMenu from '../../Component/DataGrid/Plugins/CustomMaterialMenu/CustomMaterialMenu';
import { ShowAlert } from '../../Component/ShowAlert';
import SpeakerNotesOffIcon from '@mui/icons-material/SpeakerNotesOff';
import hacker from '../../Images/hacker.png';
import { SyncContext, SyncContextType } from '../../Contexts/BatchSyncContext';
import UserAndPermissionService from '../../Services/UserAndPermissionService';
import { ISelectedDateRangeString } from '../../Component/DataGrid/Interface';
import ReusableDrawer from '../../Component/RightDrawer/ReusableDrawer';
import { fetchCountriesWithTransactions, fetchRecipientCountryList, handleDrawerApplyCommon } from '../../Component/Reusables/Recipient';
import { getLast30DaysRange, getLast7DaysRange, Texts } from '../../Component/Reusables/Utility';
import DownloadCsv from '../../Component/DataGrid/Plugins/DownloadCsv';
import { Button } from '@mui/material';

class TransactionLogs extends React.Component<TransactionLogsProps, TransactionLogsState> {
    static contextType = SyncContext;
    context!: SyncContextType;
    private tableColumns: TableColumn<ITransactionLogs>[] = [
        {
            name: 'Transaction Id',
            selector: row => row.payment_transaction_id,
            sortable: false,
            id: "TransactionId",
            minWidth: "120px",
            wrap: true,
        },
        {
            name: 'Name',
            selector: row => row.name,
            sortable: true,
            id: "Name",
            minWidth: "250px",
            wrap: true,
        },
        {
            name: 'Sender Email',
            selector: row => row.sender_email,
            sortable: true,
            id: "email",
            minWidth: "200px",
            wrap: true
        },
        {
            name: 'Sender Mobile',
            selector: row => row.sender_mobile,
            sortable: true,
            id: "mobile",
            width: "150px",
        },
        {
            name: 'Recipient',
            selector: row => row.recipient_name,
            sortable: true,
            id: "Recipient",
            minWidth: "250px",
            wrap: true,
        },
        {
            name: 'Recipient Country',
            selector: row => row.recipient_country_id,
            sortable: true,
            id: "RecipientCountry",
            // minWidth: "250px",
            wrap: true,
        },
        {
            name: 'Paid Amount',
            selector: row => amountFormat(row.paid_amount, 'en-US', 'USD'),
            sortable: true,
            id: "PaidAmount",
            right: true
        },
        {
            name: 'Payment Type',
            selector: row => row.payment_type,
            sortable: true,
            id: "payment_type",
            center: true,
            minWidth: '150px'
        },
        {
            name: 'Status',
            selector: row => row.payment_status,
            sortable: true,
            id: "status",
            center: true
        },
        {
            name: 'Compliance',
            selector: row => row.compliance,
            sortable: true,
            id: "compliance",
            cell: row => <div className='center-cell'>{row.compliance ? <SpeakerNotesOffIcon /> : '-'}</div>,
            minWidth: '120px'
        },
        {
            name: 'Fraud Detection',
            selector: row => row.fraud_detection,
            sortable: true,
            id: "fraud_detection",
            cell: row => <div className='center-cell'>{row.fraud_detection ? <img src={hacker} alt="hacker" /> : '-'}</div>
        },
        {
            name: 'Date',
            selector: row => moment(row.payment_time).format('MM-DD-YYYY hh:mm A'),//hh:mm A on Do MMMM YYYY
            sortable: true,
            id: "date",
            width: "170px",
            center: true
        },
        {
            name: 'Send Receipt',
            center: true,
            width: '160px',
            cell: (row) => (
                row.payment_status?.trim().toLowerCase() === "delivered" || row.payment_status?.trim().toLowerCase() === "failed" ? (
                    <Button
                        color='secondary'
                        variant="contained"
                        onClick={() => this.sendReceipt(row)}
                    >
                        Send Receipt
                    </Button>
                ) : null
            )
        },
        {
            name: 'Actions',
            cell: (row) => {
                const { transactionLogs } = this.state

                if (!transactionLogs.isFraudMarkVisible) return null;
                return (
                    <CustomMaterialMenu
                        fontSize="small"
                        multiPopoverItems={[
                            ...(row.fraud_detection
                                ? [{ key: "unMarkFraud", label: "Unmark Fraud" }]
                                : [{ key: "markFraud", label: "Mark Fraud" }]),
                            ...(row.payment_status?.trim().toLowerCase() !== "refunded" &&
                                row.transaction_mode?.trim().toLowerCase() === "card" &&
                                row.stripe_status?.trim().toLowerCase() === "captured"
                                ? [{ key: "voidPayment", label: "Void Payment" }]
                                : [])
                        ]}
                        onPopoverClick={(key_, label_) => {
                            if (key_ === "voidPayment") {
                                this.voidPayment(row);
                            } else {
                                this.updateFraud(row, key_, label_);
                            }
                        }}
                    />
                );
            },
            allowOverflow: true,
            button: true,
            width: "120px",
        }
    ]

    constructor(props_: TransactionLogsProps) {
        super(props_);
        let URLParams = new URLSearchParams(window.location.search);
        let transactionId = URLParams.get("id");
        let monthRange = getLast7DaysRange();
        this.state = {
            accessToken: "",
            transactionData: [],
            currentRowsPerPage: 10,
            currentPage: 1,
            totalRows: 100,
            searchText: transactionId ? transactionId : "",
            selectedDateRange:
            {
                startDate: monthRange.startDate,
                endDate: monthRange.endDate,
            },
            contentRef: React.createRef<HTMLDivElement>(),
            csvData: [],
            transactionLogs: {
                isVisible: true,
                isDownloadVisible: true,
                isFraudMarkVisible: true,
                isRefundVisible: true,
            },
            isDrawerOpen: false,
            selectedCountry: "",
            selectedTxnStatus: "",
            appliedFiltersCount: 0
        }
    }

    async componentDidMount() {
        try {
            const accessToken_ = await loadFromLocalStorage('accessToken');
            const profile_ = await loadFromLocalStorage('profile');

            if (!accessToken_ || !profile_) {
                localStorage.clear();
                window.location.href = '/';
                return;
            }

            const accessToken = accessToken_.toString();
            const userProfile = typeof profile_ === 'string' ? JSON.parse(profile_) : profile_;

            this.setState({ accessToken, appliedFiltersCount: this.state.searchText ? 0 : 1 }, async () => {
                try {
                    if (userProfile?.roleId) {
                        const permissionResponseRaw = await UserAndPermissionService.getPermissions(accessToken, userProfile?.roleId);
                        const permissionResponse = await permissionResponseRaw.json();

                        if (!permissionResponse?.permissions?.transactionLogs?.isVisible) {
                            console.warn("Permission denied, logging out...");
                            localStorage.clear();
                            window.location.href = '/';
                            return;
                        }

                        const permissions = permissionResponse.permissions

                        this.context.dispatch({
                            type: "SET_PERMISSION", payload: {
                                permissions
                            },
                        });

                        const transactionLogs = permissionResponse.permissions.transactionLogs

                        this.setState({ transactionLogs }, () => {
                            this.getTransactionHistory();
                        });

                    } else {
                        this.getTransactionHistory();
                    }
                } catch (error) {
                    console.error("Error fetching permissions:", error);
                }
            });
        } catch (error) {
            console.error("Error in componentDidMount:", error);
            localStorage.clear();
            window.location.href = '/';
        }
    }

    private async sendReceipt(row_: ITransactionLogs) {

        try {

            const response = await TransactionService.sendReceipt(this.state.accessToken, row_.transfer_id);

            if (response.ok) {
                ShowAlert("Success", "Receipt sent successfully", "success");
            } else {
                ShowAlert("Error", "Failed to send receipt", "error");
            }

        } catch (error) {

            console.error(error);
            ShowAlert("Error", "Something went wrong while sending receipt", "error");
        }
    }

    fetchDropdownOptions = () => {
        return fetchRecipientCountryList(this.state.accessToken);
    };

    // Fetches the list of countries available for transaction log filtering
    fetchTxnCountries = () => {
        return fetchCountriesWithTransactions(this.state.accessToken);
    };

    fetchTxnStatusDropdownOptions = async () => {
        const response = await TransactionService.fetchTransactionStatusList(this.state.accessToken);

        if (response?.ok) {
            const result = await response.json();
            console.log(result);
            return result;
        }

        return [];
    };

    handleDrawerApply = (filters: { selectedId: string; startDate: string | null; endDate: string | null; selectedTxnStatus: string }) => {
        const { selectedId, startDate, endDate, selectedTxnStatus } = filters;

        this.setState(
            {
                selectedCountry: selectedId || "",
                selectedDateRange: {
                    startDate: startDate || null,
                    endDate: endDate || null,
                },
                selectedTxnStatus: selectedTxnStatus,
                currentPage: 1,
            },
            () => {
                this.getTransactionHistory();
            }
        );
    };


    public render() {
        const { transactionLogs } = this.state;

        return (
            <div className='body-sub-contianer table-container'>
                {/* <h1>Transaction Logs</h1> */}
                <DataGrid
                    title={this.props.userId ? "" : 'Transaction Logs'}
                    gridId={this.props.gridId}
                    search='Transaction Logs'
                    //isDatePickerNeeded
                    isClearDateOnSearch
                    defaultSearch={this.state.searchText}
                    onSearch={(searchText_: string, selectedDateRange: ISelectedDateRangeString | null) => {
                        const newDate = selectedDateRange === null ? { startDate: null, endDate: null } : selectedDateRange;
                        this.setState({
                            searchText: searchText_,
                            currentPage: 1,
                            selectedDateRange: newDate,
                            appliedFiltersCount: searchText_ ? 0 : selectedDateRange !== null ? 1 : this.state.appliedFiltersCount,
                            selectedCountry: searchText_ ? '' : this.state.selectedCountry
                        }, () => {
                            this.getTransactionHistory();
                        })
                    }}
                    onApply={(filteredDate: { startDate: string, endDate: string }) => {
                        this.setState({
                            selectedDateRange: filteredDate,
                            currentPage: 1
                        }, () => {
                            this.getTransactionHistory();
                        })
                    }}
                    columns={this.tableColumns}
                    data={this.state.transactionData}
                    // csvData={this.state.csvData}
                    expandableRows
                    onChangePage={(page: number, totalRows: number) => {
                        //console.log(page, totalRows);
                        this.setState({
                            currentPage: page
                        }, () => {
                            this.getTransactionHistory();
                        })
                    }}
                    onChangeRowsPerPage={(currentRowsPerPage_: number, currentPage_: number) => {
                        //console.log(currentRowsPerPage_, currentPage_);
                        this.setState({
                            currentRowsPerPage: currentRowsPerPage_,
                            currentPage: currentPage_
                        }, () => {
                            this.getTransactionHistory();
                        })
                    }}
                    pagination
                    paginationTotalRows={this.state.totalRows}
                    expandedComponent={(data_: any) => <TransactionDetails
                        transactionLogs={transactionLogs}
                        details={data_.data}
                        accessToken={this.state.accessToken}
                        onRefundDone={(pageRefresh: boolean) => {
                            if (pageRefresh) {
                                this.getTransactionHistory();
                            }
                        }} />}
                    exportCsv={transactionLogs.isDownloadVisible ? true : false}
                    isDrawerRequired={true}
                    isDrawerOpen={() => this.setState({ isDrawerOpen: true })}
                    appliedFiltersCount={this.state.appliedFiltersCount}
                    selectedCountry={this.state.selectedCountry}
                    prepareCSVCustom={this.prepareCSVCustom}
                    parentComponent={this}
                />
                <ReusableDrawer
                    open={this.state.isDrawerOpen}
                    onClose={() => this.setState({ isDrawerOpen: false })}
                    onApply={this.handleDrawerApply}
                    fetchCountriesWithTransactions={this.fetchTxnCountries}
                    defaultValue={this.state.selectedCountry}
                    onFiltersCountChange={(count) => this.setState({ appliedFiltersCount: count })}
                    defaultStartDate={this.state.searchText ? '' : this.state.selectedDateRange.startDate}
                    defaultEndDate={this.state.searchText ? '' : this.state.selectedDateRange.endDate}
                    fetchTxnStatusDropdownOptions={this.fetchTxnStatusDropdownOptions}
                    defaultTxnStatus={this.state.selectedTxnStatus}
                    showDateRange={true}
                    showTransactionLogCountryFilter={true}
                    showTxnStatusFilter={true}
                />
            </div>
        )
    }

    public async getCSVData(startDate: string | null, endDate: string | null): Promise<any[]> {
        let postData: any = {
            "startDate": startDate,
            "endDate": endDate
        }
        if (this.state.searchText) {
            postData.searchText = this.state.searchText
        }
        if (this.state.selectedCountry) {
            postData.countryId = this.state.selectedCountry
        }
        try {
            const response = await TransactionService.getTransactionHistoryForCSV(this.state.accessToken, postData, this.props.userId);

            if (!response.ok) {
                throw new Error("Failed to download CSV");
            }
            // Handle binary CSV data
            const blob = await response.blob();

            // Convert blob to text
            const csvText = await blob.text();

            // Parse CSV to array of transaction objects
            const transactions = this.parseCSVToTransactions(csvText);

            return transactions; // Return array of transactions

        } catch (error) {
            console.error("CSV download error:", error);
            ShowAlert("Error", "Failed to download CSV", "error");
            return []; // Return empty array on error
        }
    }

    /**
     * Parse CSV string to array of transaction objects with nested transaction_details
     */
    private parseCSVToTransactions(csvText: string): any[] {
        if (!csvText || csvText.trim().length === 0) {
            return [];
        }

        // Split into lines and filter out empty lines
        const lines = csvText.split('\n').filter(line => line.trim().length > 0);
        if (lines.length < 2) {
            return [];
        }

        // Get headers from first line
        const headers = this.parseCSVLine(lines[0]);
        const cleanHeaders = headers.map(h => h.replace(/"/g, '').trim());

        // Group transactions by transfer_id + payment_transaction_id
        const transactionMap = new Map<string, any>();

        // Parse each data row
        for (let i = 1; i < lines.length; i++) {
            const values = this.parseCSVLine(lines[i]);
            const row: any = {};

            cleanHeaders.forEach((header, index) => {
                row[header] = values[index] ? values[index].replace(/"/g, '') : '';
            });

            // Create unique key for this transaction
            const key = `${row.transfer_id}_${row.payment_transaction_id}`;

            if (!transactionMap.has(key)) {
                // Create new transaction entry
                const transaction: any = {
                    transfer_id: row.transfer_id,
                    payment_transaction_id: row.payment_transaction_id,
                    name: row.name,
                    sender_email: row.sender_email,
                    sender_mobile: row.sender_mobile,
                    paid_amount: row.paid_amount,
                    payment_status: row.payment_status,
                    status_reason: row.status_reason,
                    payment_time: row.payment_time,
                    processed_time: row.processed_time,
                    created_utc: row.payment_time, // Use payment_time as created_utc
                    modified_utc: row.processed_time, // Use processed_time as modified_utc
                    transaction_details: []
                };

                transactionMap.set(key, transaction);
            }

            // Add transaction detail to the existing transaction
            const transaction = transactionMap.get(key)!;
            transaction.transaction_details.push({
                transaction_id: row.transaction_id,
                account: row.account,
                channel: row.channel,
                payment_method_type: row.payment_method_type,
                from_currency_rate: row.from_currency_rate,
                to_currency_rate: row.to_currency_rate,
                sender_currency: row.sender_currency,
                sender_amount: row.sender_amount,
                destination_currency: row.destination_currency,
                destination_amount: row.destination_amount,
                markup_percentage: row.markup_percentage,
                markup_value: row.markup_value,
                platform_fee_value: row.platform_fee_value,
                platform_fee: row.platform_fee,
                total_amount: row.total_amount,
                transaction_status: row.transaction_status,
                created_utc: row.created_utc || row.payment_time,
                modified_utc: row.modified_utc || row.processed_time,
                response_code: row.response_code,
                response_message: row.response_message,
                uniwallet_transactionId: row.uniwallet_transactionId
            });
        }

        // Convert Map to array
        const transactions = Array.from(transactionMap.values());

        // Sort by created_utc (oldest first) to match existing behavior
        return transactions.sort((a, b) => {
            const dateA = new Date(a.created_utc || a.payment_time).getTime();
            const dateB = new Date(b.created_utc || b.payment_time).getTime();
            return dateA - dateB;
        });
    }

    /**
     * Parse a CSV line handling quoted values and escaped quotes
     */
    private parseCSVLine(line: string): string[] {
        const values: string[] = [];
        let currentValue = '';
        let insideQuotes = false;

        for (let i = 0; i < line.length; i++) {
            const char = line[i];

            if (char === '"') {
                // Check for escaped quotes (double quotes)
                if (i + 1 < line.length && line[i + 1] === '"') {
                    currentValue += '"';
                    i++; // Skip next quote
                } else {
                    insideQuotes = !insideQuotes;
                }
            } else if (char === ',' && !insideQuotes) {
                values.push(currentValue);
                currentValue = '';
            } else {
                currentValue += char;
            }
        }

        // Push the last value
        values.push(currentValue);

        return values;
    }

    private getTransactionHistory() {
        let pageIndex: number = this.state.currentPage;
        let monthRange = getLast30DaysRange();
        let startDate, endDate;
        console.log(this.state.selectedDateRange.startDate, this.state.searchText);

        if (this.state.selectedDateRange.startDate == '' || this.state.selectedDateRange.startDate == "Invalid date") {
            this.setState({
                selectedDateRange: {
                    startDate: monthRange.startDate,
                    endDate: monthRange.endDate,
                },
                appliedFiltersCount: 1
            });
            startDate = monthRange.startDate;
            endDate = monthRange.endDate;
        } else {
            startDate = this.state.selectedDateRange.startDate;
            endDate = this.state.selectedDateRange.endDate;
        }
        // const startDate = this.state.selectedDateRange.startDate;
        // const endDate = this.state.selectedDateRange.endDate;
        // const startDate = this.state.selectedDateRange.startDate ? monthRange.startDate : this.state.selectedDateRange.startDate;
        // const endDate = this.state.selectedDateRange.endDate ? monthRange.endDate : this.state.selectedDateRange.endDate;
        let postData: any
        postData = {
            "pageNumber": pageIndex,
            "recordPerPage": this.state.currentRowsPerPage,
            "startDate": startDate,
            "endDate": endDate
        }
        if (this.state.searchText) {
            postData["searchText"] = this.state.searchText;
        }
        if (this.state.selectedCountry) {
            postData["countryId"] = this.state.selectedCountry
        }
        if (typeof this.state.selectedTxnStatus === "number") {
            postData["txnStatusId"] = this.state.selectedTxnStatus
        }

        //console.log(postData, '=========> postDate');
        TransactionService.getTransactionHistory(this.state.accessToken, postData, this.props.userId).then(tr => {
            if (tr.ok) {
                tr.json().then(resp => {
                    this.setState({
                        transactionData: resp.transactionList,
                        totalRows: resp.totalRecords
                    })
                });
            }
        });
        // this.getCSVData(startDate, endDate);
    }

    private async updateFraud(row_: ITransactionLogs, key_: string, label_: string) {
        let postdata: any = {
            "transactionId": row_.payment_transaction_id,
            "fraudDetection": key_ == "markFraud"
        }

        let tr = await TransactionService.updateFraud(this.state.accessToken, postdata);
        let message = key_ == "markFraud" ? "fraudulent" : "not fraudulent";

        if (tr.ok) {
            ShowAlert("PassportPay", `The transaction has been marked as ${message}.`, 'success').then(() => {
                this.getTransactionHistory();
            });
        }
    }

    private async voidPayment(row_: ITransactionLogs) {
        const postdata = {
            externalTransactionId: row_.payment_transaction_id,
            amount: row_.paid_amount,
        };

        try {
            const tr = await TransactionService.voidPayment(this.state.accessToken, postdata);

            if (tr.ok) {
                const message = "Void payment successfully initiated.";
                await ShowAlert("Sucsess", message, "success");

                this.getTransactionHistory();
            }
        } catch (error) {
            console.error(error);
            ShowAlert("PassportPay", "An error occurred while voiding the payment.", "error");
        }
    }

    // This is for transaction page csv downloads...
    private prepareCSVCustom(objDownloadCSV: DownloadCsv<ITransactionLogs>) {
        let _thisComponent = objDownloadCSV.props.parentComponent as TransactionLogs;
        _thisComponent.getCSVData(_thisComponent.state.selectedDateRange.startDate, _thisComponent.state.selectedDateRange.endDate).then((serverData: ITransactionLogs[]) => {
            if (!serverData || serverData.length === 0) {
                objDownloadCSV.errormsg();
                return;
            }
            _thisComponent.serverExportCallback(objDownloadCSV, serverData);
        });

    }

    // This is for transaction page csv downloads...
    private serverExportCallback(objDownloadCSV: DownloadCsv<ITransactionLogs>, serverData: ITransactionLogs[]) {
        let _thisComponent = objDownloadCSV.props.parentComponent as TransactionLogs;
        // Define two different sets of columns as required
        const priority_transaction_column = [
            "transfer_id",
            "payment_transaction_id",
            "name",
            "sender_email",
            "sender_mobile",
            "paid_amount",
            "payment_status",
            "status_reason",
            "payment_time",
            "processed_time"
        ];

        const itc_transaction_column = [
            "transfer_id",
            "payment_transaction_id",
            "transaction_id",
            "account",
            "channel",
            "payment_method_type",
            "from_currency_rate",
            "to_currency_rate",
            "sender_currency",
            "sender_amount",
            "destination_currency",
            "destination_amount",
            "markup_percentage",
            "markup_value",
            "platform_fee_value",
            "platform_fee",
            "total_amount",
            "transaction_status",
            "created_utc",
            "modified_utc",
            "response_code",
            "response_message",
            "uniwallet_transactionId"
        ];

        // Extract and format dates
        const startDate = moment(_thisComponent.state.selectedDateRange.startDate).format(Texts.formatDateDisplay);
        const endDate = moment(_thisComponent.state.selectedDateRange.endDate).format(Texts.formatDateDisplay);

        // Construct filenames dynamically
        let priorityFileName = `Priority_Transactions_${startDate}_to_${endDate}.csv`;
        let itcFileName = `ITC_Transactions_${startDate}_to_${endDate}.csv`;

        // if start or end date null remove the date from file name
        if (_thisComponent.state.selectedDateRange.startDate === null || _thisComponent.state.selectedDateRange.endDate === null) {
            priorityFileName = `Priority_Transactions.csv`;
            itcFileName = `ITC_Transactions.csv`;
        }


        let arrPriority = [];
        let arrITC = [];
        for (let itemPriority of serverData) {
            if (itemPriority.transaction_details) {
                for (let i = 0; i < itemPriority.transaction_details.length; i++) {
                    let newItem = { ...itemPriority, ...itemPriority.transaction_details[i] };
                    delete newItem.transaction_details;
                    if (i === 0) {
                        arrPriority.push(newItem);
                    }
                    arrITC.push(newItem);
                }
            }
        }

        // Sort by created_utc
        const sortedArrayPriority = arrPriority.sort((a, b) =>
            new Date(a.created_utc as string).getTime() - new Date(b.created_utc as string).getTime()
        );
        const sortedArrayITC = arrITC.sort((a, b) =>
            new Date(a.created_utc as string).getTime() - new Date(b.created_utc as string).getTime()
        );
        // Generate and download first CSV file
        _thisComponent.prepareCSVForTransLogs(sortedArrayPriority, priority_transaction_column, priorityFileName, objDownloadCSV);
        // Generate and download second CSV file
        _thisComponent.prepareCSVForTransLogs(sortedArrayITC, itc_transaction_column, itcFileName, objDownloadCSV);
    }


    private prepareCSVForTransLogs(array: ITransactionLogs[], includedColumns: string[], fileName: string, objDownloadCSV: DownloadCsv<ITransactionLogs>) {
        let pivotedArray = this.pivotForTransLog(array, includedColumns, objDownloadCSV);
        let csv = objDownloadCSV.toCsvByReplacingSingleToDoubleQuote(pivotedArray);
        objDownloadCSV.downloadCSV(csv, fileName);
    }

    private pivotForTransLog(arr: ITransactionLogs[], includedColumns: string[], objDownloadCSV: DownloadCsv<ITransactionLogs>) {
        const header = includedColumns;

        // Declare time-related fields explicitly for formats..
        const timeFields = [
            "payment_time",
            "processed_time",
            "created_utc",
            "modified_utc"
        ];

        const rows = arr.map(obj =>
            header.map(key => {
                let value = (obj as any)[key] ?? ''; // Default to empty string if value is missing

                if (key === "mobileNumber" && typeof value === "string") {
                    value = `="${value}"`;
                }

                // Convert only time fields
                if (timeFields.includes(key)) {
                    value = objDownloadCSV.formatToLocalTime(value);
                }

                return value;
            })
        );
        return [header, ...rows];
    }
}

export default TransactionLogs;